import { AtSymbolIcon, PhoneIcon } from '@heroicons/react/24/outline';
import { StyledLink } from '../ui';
import { useTranslation } from 'react-i18next';
import { OfferRow } from '../offer-row';
import { useWindowSize } from 'usehooks-ts';

export function Header() {
  const { t } = useTranslation();
  const { width = 0 } = useWindowSize();

  return (
    <header className="pb-4">
      <div className="grid grid-cols-5 sm:hidden w-full justify-center p-2 items-center">
        <div />

        <div className="flex col-span-3 items-center justify-center shrink-0">
          <img
            className="h-5 m-2"
            alt="Logo Mandira"
            src="https://cdn.mandira-ayurveda.at/images/text/2024/black.png"
          ></img>
        </div>

        <div className="flex items-center justify-end">
          <StyledLink
            href="tel:+4333332801"
            classNames="flex items-center gap-1"
          >
            <PhoneIcon className="w-4 h-4"></PhoneIcon>
            <span className="sr-only">{t('header.call')}</span>
          </StyledLink>
        </div>
      </div>

      <OfferRow></OfferRow>

      <div className="container px-2 grid sm:grid-cols-3 items-center justify-center mt-6 sm:mt-0">
        <div />

        <div className="flex justify-center">
          {width >= 640 ? (
            <a href="https://www.mandira-ayurveda.at">
              <img
                className="h-16"
                alt="Logo Mandira"
                src="https://cdn.mandira-ayurveda.at/images/logo/2024/dark_cyan_text_black.png"
              ></img>
              <span className="sr-only">{t('header.to-homepage')}</span>
            </a>
          ) : (
            <a href="https://www.mandira-ayurveda.at">
              <img
                className="h-8"
                alt="Logo Mandira"
                src="https://cdn.mandira-ayurveda.at/images/icon/2024/dark_cyan.png"
              ></img>
              <span className="sr-only">{t('header.to-homepage')}</span>
            </a>
          )}
        </div>
        <div id="header-actions" className="hidden sm:flex gap-2 justify-end ">
          <StyledLink
            href="tel:+4333332801"
            classNames="flex items-center gap-1"
          >
            <PhoneIcon className="w-4 h-4"></PhoneIcon> {t('header.call')}
          </StyledLink>

          <StyledLink
            href="mailto:info@mandira-ayurveda.at"
            classNames="hidden md:flex items-center gap-1"
          >
            <AtSymbolIcon className="w-4 h-4"></AtSymbolIcon> {t('header.mail')}
          </StyledLink>
        </div>
      </div>

      <div className="hidden sm:block pt-5">
        <hr />
      </div>
    </header>
  );
}

export default Header;
